import type { ModalBodyProps } from '@ui/core/modal/body/ModalBody';
import { createRendererStateManager } from '@ui/core/utils/state-manager';

export const modalState = createRendererStateManager<ModalBodyProps>();
